import React from 'react';
import { AwardIcon, GraduationCapIcon, ShieldCheckIcon, MapIcon } from 'lucide-react';
const items = [{
  icon: AwardIcon,
  text: '25+ years modality experience'
}, {
  icon: GraduationCapIcon,
  text: 'Training and implementation support'
}, {
  icon: ShieldCheckIcon,
  text: 'Curated products, not hype-driven recommendations'
}, {
  icon: MapIcon,
  text: 'Serving practices across the United States'
}];
export function ProofStrip() {
  return <section className="w-full border-y border-slate-100 bg-slate-50/60" data-id="element-237" data-mp="1w2o2hx57zw61">
      <div className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-slate-100 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:divide-x lg:divide-y-0" data-id="element-238" data-mp="212akejvzu0l6">
        {items.map(({
        icon: Icon,
        text
      }) => <div key={text} className="flex items-start gap-3 px-0 py-6 lg:px-6" data-id="element-239" data-mp="18dmvmec1ct2v">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-240" data-mp="18bshpjz6m18a">
              <Icon className="h-[18px] w-[18px]" data-id="element-241" data-mp="3v8ado7haqce3" />
            </span>
            <p className="text-[13.5px] font-medium leading-snug text-charcoal" data-id="element-242" data-mp="3v7ihaufvkamr">
              {text}
            </p>
          </div>)}
      </div>
    </section>;
}